export function EmptyState({
  icon,
  title,
  body,
  action,
  compact = false
}: {
  icon?: string;
  title: string;
  body: string;
  action?: { label: string; onClick: () => void };
  compact?: boolean;
}): JSX.Element {
  return (
    <div
      className={`text-center text-text-muted ${compact ? 'p-9' : 'py-[60px] px-5'}`}
      role="status"
      aria-live="polite"
    >
      {icon ? (
        <div
          className={`${compact ? 'w-[38px] h-[38px] text-base mb-2.5' : 'w-12 h-12 text-xl mb-3.5'} rounded-full bg-panel-2 border border-dashed border-border-strong inline-grid place-items-center text-text-muted`}
        >
          {icon}
        </div>
      ) : null}
      <div
        className={`${compact ? 'text-[12.5px]' : 'text-[13.5px]'} text-text-dim font-medium mb-1.5`}
      >
        {title}
      </div>
      <div
        className={`${compact ? 'text-[11.5px]' : 'text-xs max-w-[380px] mx-auto mb-3.5'}`}
      >
        {body}
      </div>
      {action ? (
        <button
          type="button"
          onClick={action.onClick}
          className="px-3.5 py-1.5 bg-panel-2 border border-border text-text rounded-md text-xs cursor-pointer hover:border-border-strong"
        >
          {action.label}
        </button>
      ) : null}
    </div>
  );
}
